import React from 'react';
import logo from './logo.svg';
import './App.less';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProjectLayout from './layout';
import { SystemStatus, useSystemService } from './commons/context/system-store';
import { BimStatus, useBimService } from './commons/context/bim-store';
import { DownloadPanel, DownloadState, UploadFileState, UploadPanel, useDownloadService, useUploadService } from 'tncet-common';
import { checkManageFileExists, getFileUrl, getManageFileUploadUrl } from './api/project/file';
import LoginMain from './layout/login';

// 默认激活的Uuid
export const GlobalProjectUuid = '6ad6b2f7-d5db-4bf3-afbd-7a80e9f02646';

export const SystemContext = React.createContext<SystemStatus>(null);
export const BimContext = React.createContext<BimStatus>(null);
export const UploadFileContext = React.createContext<UploadFileState>(null);
export const DownloadContext = React.createContext<DownloadState>(null);

function App() {
    const systemContext = useSystemService();
    return (
        <SystemContext.Provider value={systemContext}>
            <BimContext.Provider value={useBimService()}>
                <UploadFileContext.Provider value={useUploadService()}>
                    <DownloadContext.Provider value={useDownloadService()}>
                        <div className="tn-base">
                            <Routes>
                                <Route path='/projects/:projectUuid/buildings/:buildingUuid' element={<ProjectLayout />} />
                                <Route path='/projects/:projectUuid/massic' element={<LoginMain />} />
                                <Route path='/projects/:projectUuid/*' element={<LoginMain />} />
                                <Route path="*" element={<Navigate to={`/projects/${GlobalProjectUuid}/massic`} />} />
                            </Routes>
                        </div>
                        <UploadPanel checkFileExists={checkManageFileExists} getUploadUrl={getManageFileUploadUrl}
                            uploadContext={UploadFileContext} />
                        <DownloadPanel downloadContext={DownloadContext} getFileUrl={getFileUrl}/>
                    </DownloadContext.Provider>

                </UploadFileContext.Provider>
            </BimContext.Provider>
        </SystemContext.Provider>

    );
}

export default App;
